import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Theme settings
  mode: 'light', // 'light' or 'dark'
  topbar: 'light', // 'light' or 'dark'
  sidebar: 'light', // 'light', 'dark', 'brand'
  sidebarSize: 'default', // 'default', 'compact', 'small'
  layoutMode: 'light', // 'light' or 'dark'
  layoutWidth: 'fluid', // 'fluid' or 'boxed'
  layoutPosition: 'fixed', // 'fixed' or 'scrollable'
  
  // Novu notification settings (theme-related only)
  novu: {
    isDarkMode: false, // Derived from theme.mode but can be overridden
    isOpen: false, // Notification dropdown state
  },
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      return { ...state, ...action.payload };
    },
    toggleDarkMode: (state, action) => {
      const isDark = action.payload;
      state.mode = isDark ? 'dark' : 'light';
      state.topbar = isDark ? 'dark' : 'light';
      state.sidebar = isDark ? 'dark' : 'light';
      state.layoutMode = isDark ? 'dark' : 'light';
      // Update Novu dark mode setting
      state.novu.isDarkMode = isDark;
    },
    setSidebarSize: (state, action) => {
      state.sidebarSize = action.payload;
    },
    setSidebarColor: (state, action) => {
      state.sidebar = action.payload;
    },
    setLayoutWidth: (state, action) => {
      state.layoutWidth = action.payload;
    },
    setLayoutPosition: (state, action) => {
      state.layoutPosition = action.payload;
    },
    resetTheme: () => initialState,
    
    // Novu theme-related actions
    toggleNovuDropdown: (state, action) => {
      state.novu.isOpen = action.payload !== undefined ? action.payload : !state.novu.isOpen;
    },
    setNovuDarkMode: (state, action) => {
      state.novu.isDarkMode = action.payload;
    },
  },
});

export const { 
  setTheme, toggleDarkMode, setSidebarSize, setSidebarColor, setLayoutWidth, 
  setLayoutPosition, resetTheme, toggleNovuDropdown, setNovuDarkMode
} = themeSlice.actions;

export default themeSlice.reducer;